import { render, staticRenderFns } from "./PromotionCompletion.vue?vue&type=template&id=79d6c461&"
import script from "./PromotionCompletion.vue?vue&type=script&lang=js&"
export * from "./PromotionCompletion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports